import { Component } from '@angular/core';
import { RegulatedProductService } from '../regulated-products.service';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import { ICrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.interface';
import {
  IRegulatedProduct,
  REGULATED_PRODUCT_TTL_ES
} from '../regulated-product.interface';
import { getTagColor } from '../../../../../helpers/tag-color.helpers';

@Component({
  selector: 'pg-regulated-product',
  templateUrl: './regulated-products.component.html'
})
export class RegulatedProductComponent
  extends CrudTemplate
  implements ICrudTemplate
{
  constructor(private regulatedProductService: RegulatedProductService) {
    super(REGULATED_PRODUCT_TTL_ES, regulatedProductService);
  }

  ngOnInit() {
    this.table.settings = {
      title: REGULATED_PRODUCT_TTL_ES,
      columns: [
        { header: 'Código', field: 'code' },
        { header: 'Código de barras', field: 'barCode' },
        { header: 'Nombre', field: 'name' },
        { header: 'Concentración', field: 'concentration' },
        { header: 'FormDet', field: 'form' },
        { header: 'FormSim', field: 'formSimp' },
        { header: 'Presentación', field: 'presentation' },
        { header: 'Laboratorio', field: 'laboratory' },
        { header: 'Fracción', field: 'fractions' },
        { header: 'Condición', field: 'condition', tag: 'tagStatus' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.regulatedProductService
      .getData$()
      .subscribe((data: IRegulatedProduct[]) => {
        data = data.map((item) => {
          item.tagStatusColor = getTagColor(item.conditionCode);
          return item;
        });
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
